"use client";

import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const FeatureFlagsContext = createContext(undefined);
const defaultFeatureFlags = {
  showPoints: true
};
export function FeatureFlagsProvider({
  children,
  featureFlags = defaultFeatureFlags
}) {
  return _jsx(FeatureFlagsContext.Provider, {
    value: {
      featureFlags
    },
    children: children
  });
}
export function useFeatureFlags() {
  const context = useContext(FeatureFlagsContext);
  if (!context) {
    return defaultFeatureFlags;
  }
  return context.featureFlags;
}